module.exports = __webpack_public_path__ + "static/mclaren-d825da14698817ef3be4742faf585587.jpg";